(function () {
    'use strict';

    angular
        .module('oddCampaignModule')
        .directive('oddCampaignInviteDetails', directive);

    directive.$inject = ['boxTmplScope', 'boxTmplHtml', 'boxTmplLinkFn'];

    function directive(boxTmplScope, boxTmplHtml, boxTmplLinkFn) {

        var directiveScope = _.clone(boxTmplScope);
        directiveScope.addCampaign = '&';

        return {
            scope: directiveScope,
            template: boxTmplHtml,
            controller: ['$rootScope', '$scope', '$controller',
                function ($rootScope, $scope, $controller) {

                    // Box Template
                    $scope.baseTemplatePath = '/app/shared/odd/campaign/oddCampaignInviteDetails.[Template].tpl.html';
                    $controller('BoxTmplController', { $scope: $scope });

                    $scope.updateModel = function (newModel) {
                        $scope.boxModel = newModel;
                    };

                    $scope.goToInviteDetails = function (inviteDetails) {
                        $scope.clickOnBox({ inviteDetails: inviteDetails });
                    };
                }],
            link: function (scope, elem, attrs) {
                boxTmplLinkFn(scope, elem, attrs);
            }
        }
    }
})();